import { getMasonryWSDriver } from '@leagueplatform/masonry';

export const formsCenterMasonryConfig = {
  appId: 'cigna_form_center',
  screenName: 'form-center',
  productArea: 'cigna_form_center',
  apiParams: {},
};

export const FormsCenterMasonryDriver = getMasonryWSDriver(
  formsCenterMasonryConfig,
);
